import * as React from 'react';
import { Link } from 'office-ui-fabric-react';

const StyleSettingsTooltip = () => <div>
    Customize a logo and define a style for your PPM Express tenant.<br />
    Please refer to the <Link href="https://help.ppm.express/89495-ppm-express-settings/522610" target="_blank">article</Link> for more details.
</div>

export default StyleSettingsTooltip;
